<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="DocId"
      ref="list"
      unit="任务数据查询"
      :page="page"
      @getDetail="getDetail"
      :show-checkbox="true"
      :show-query="true"
      :showExpand="true"
      :get-data-func="api.getCTaskList"
      urlHash="scada/gather/transceiverassistant/taskdata"
      :showTrendTable="showTrendTable"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
      
      <template #expand-content="{ row: rows,index:i }">
        <div>
          <el-table ref="table" :data="rows.Products" border  style="width: 1100px" >
            <el-table-column prop="ProductName" label="产品名" min-width="100"  />
            <el-table-column prop="ProductSpec" label="规格型号" min-width="100"  />
            <el-table-column prop="UnitName" label="单位" min-width="100"  />
            <el-table-column prop="Quantity" label="任务数" min-width="100"  />
          </el-table>
        </div>
      </template>
    </list>
    <!-- <detail-dialog ref="detailDialog"></detail-dialog> -->
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
// import detailDialog from "@/components/personnel/result/record/detailDialog";

export default {
  mixins: [listMixin],
  components: { 
    list, 
    // detailDialog 
  },
  props:{
    showTrendTable:{
      type:Boolean,
      default:true
    },
    modelType:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      api: require("@/api/pr/pdaStorage").default,
      params: {
        EmpName: "",
        IDNumber: "",
        Age: "",
        Sex: 1,
        MaritalStatus: 1,
        Birthday: "",
        NativePlace: "",
        Address: "",
        Phone: null,
        Email: "",
        EntryDate: "",
        EntryWork: "",
        EntryLv: null,
        EntryStatus: 1,
        EntryDp: "",
        EntryEmpType: "",
        School: "",
        Education: "",
        Major: "",
        Contact: "",
        EmergencyPhone: "",
        ContactRelationship: "",
      },
    };
  },
  methods: {
    //
    getDetail(data) {
      this.$refs.detailDialog.openDetails(data);
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>